module.exports = __webpack_public_path__ + "img/favicon.b0bee936.png";